import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Zap } from "lucide-react";

// Banner "unisciti al Boost": appare su qualsiasi device quando c'è una
// sessione Production Boost attiva per l'utente (sync PC <-> mobile).
export default function BoostJoinBanner() {
  const location = useLocation();
  const navigate = useNavigate();
  const [session, setSession] = useState(null);

  useEffect(() => {
    if (location.pathname.startsWith("/boost")) return;
    let alive = true;
    const check = () => {
      api.get("/boost/active").then((r) => {
        if (alive) setSession(r.data.active ? r.data.session : null);
      }).catch(() => {});
    };
    check();
    const t = setInterval(check, 20000);
    return () => { alive = false; clearInterval(t); };
  }, [location.pathname]);

  if (!session || location.pathname.startsWith("/boost")) return null;

  const done = Object.keys(session.outcomes || {}).length;
  const total = (session.queue || []).length;

  return (
    <button
      onClick={() => navigate(`/boost/${session.id}`)}
      data-testid="boost-join-banner"
      className="fixed z-[80] left-1/2 -translate-x-1/2 flex items-center gap-2.5 px-5 py-3 rounded-full text-white font-bold text-sm shadow-2xl boost-banner-pulse"
      style={{
        bottom: "calc(18px + env(safe-area-inset-bottom, 0px))",
        background: "linear-gradient(90deg, #FF158A 0%, #FF642E 100%)",
        boxShadow: "0 8px 32px -4px rgba(255,21,138,0.6)",
      }}
    >
      <Zap className="w-4.5 h-4.5" fill="currentColor" />
      BOOST ATTIVO · {done}/{total} — UNISCITI
    </button>
  );
}
